import aesReduxConstants from '../constants';
import mapViewApi from '../apis/mapViewApi';

const mapViewActionsFactory = function() {
  const actions = {};
  const constants = aesReduxConstants.MAP_VIEW;

  const getActionType = function(action, status) {
    let actionType = null;

    if (constants.hasOwnProperty(action.toUpperCase())) {
      actionType = constants[action.toUpperCase()];
    }

    if (status && actionType !== null) {
      actionType += (`_${status.toUpperCase()}`);
    }

    return actionType;
  };

  const getOptions = function(type, context, id) {
    const options = {};

    if (type === 'global') {
      return options;
    }

    options.clientId = context.clientId;

    if (type === 'user') {
      options.userId = context.userId;
    }

    if (id) {
      options.id = id;
    }

    return options;
  };


  /*
   * Create Map View
   */
  actions.createMapView = function(type, mapView) {
    return function(dispatch, getState) {
      const actionType = getActionType('create', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context);

      const success = function() {
        dispatch({ type: getActionType('create', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to create Map View';

        dispatch({ type: getActionType('create', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapViewApi.createMapView(options, mapView).then(success, failure);
    };
  };


  /*
   * Delete Map View
   */
  actions.deleteMapView = function(type, id) {
    return function(dispatch, getState) {
      const actionType = getActionType('delete', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, id);

      const success = function() {
        dispatch({ type: getActionType('delete', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to delete Map View';

        dispatch({ type: getActionType('delete', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapViewApi.deleteMapView(options).then(success, failure);
    };
  };


  /*
   * Get Map View
   */
  actions.getMapView = function(type, id) {
    return function(dispatch, getState) {
      const actionType = getActionType('get', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, id);

      const success = function(response) {
        dispatch({ type: getActionType('get', 'success'), payload: response.data });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to retrieve Map View';

        dispatch({ type: getActionType('get', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapViewApi.getMapView(options).then(success, failure);
    };
  };

  /*
   * Get Map Views
   */
  actions.getMapViews = function(type) {
    return function(dispatch, getState) {
      const actionType = getActionType('get_all', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context);

      const success = function(response) {
        let data = response.data.list;

        if (response.data.hasOwnProperty('clientList')) data = [].concat(response.data.list, response.data.clientList);

        dispatch({ type: getActionType('get_all', 'success'), payload: data });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to retrieve Map Views';

        dispatch({ type: getActionType('get_all', 'success'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapViewApi.getMapViews(options).then(success, failure);
    };
  };


  /*
   * Set default Map View
   */
  actions.setDefaultMapView = function(id) {
    return function(dispatch, getState) {
      const actionType = getActionType('set_default', 'request');

      const { context } = getState().user;
      const options = getOptions('user', context, id);

      const success = function() {
        dispatch({ type: getActionType('set_default', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to set default Map View';

        dispatch({ type: getActionType('set_default', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapViewApi.setDefaultMapView(options).then(success, failure);
    };
  };


  /*
   * Update Map View
   */
  actions.updateMapView = function(type, mapView) {
    return function(dispatch, getState) {
      const actionType = getActionType('update', 'request');

      const { context } = getState().user;
      const options = getOptions(type, context, mapView.id);

      const success = function() {
        dispatch({ type: getActionType('update', 'success') });
      };

      const failure = function(error) {
        console.error(error);

        error.title = 'Unable to update Map View';

        dispatch({ type: getActionType('update', 'failure'), error });

        throw error;
      };

      dispatch({ type: actionType });

      return mapViewApi.updateMapView(options, mapView).then(success, failure);
    };
  };

  return actions;
};

export default mapViewActionsFactory();
